const instances = [
  {
    id: 'amir-al0',
    name: 'HPC Konya',
    config: 'hpc',
  },
  {
    id: 'amir-tr0',
    name: 'AYD Konya',
    config: 'ayd',
  },
  {
    id: 'amir-ps0',
    name: 'Pusula',
    config: 'pusula',
  },
  {
    id: 'yerlem-tr-0',
    name: 'Yerlem',
    config: 'yerlem',
  },
];

export default instances;
